/**
 * 通用底部Footer
 */
import React, { useEffect, useState } from "react"
import { AdviseIcon, LowVersionIcon, MobileIcon, NavIcon } from "../icon"
import { quotedata } from "../quotedata"
import { isIOS } from "../utils"
import "./index.less"
import { zoomData } from "../quotedata/index"

export function CommonFooter(props: { quotedata: quotedata; hide_fix_bottom: boolean }) {
  const [appfenxiang, setAppFenxiang] = useState(location.search.indexOf("appfenxiang=1"))
  const [shareId, setShareId] = useState("")
  const [mdtype, setMdtype] = useState("")

  const clickAdvise = () => {
    window.location.href = "//m.eastmoney.com/feedback?backurl=" + window.location.href
  }

  const clickLowVersion = () => {
    window.location.href = "https://marketing.dfcfs.com/activitytemplate/?activityId=1800"
  }

  const clickDownloadApp = () => {
    if (appfenxiang > -1) {
      location.href = `https://mlink.eastmoney.com/h52n/nlink.html?type=localurl&id=${shareId}&mdtype=${mdtype}`
    } else {
      location.href = `https://mlink.eastmoney.com/h52n/nlink.html?type=localurl&id=${shareId}&curl=xxlout_dfcfappdfcfWAP_random_0006008a`
    }
  }

  useEffect(() => {
    if (isIOS()) {
      setShareId(encodeURIComponent(`eastmoney://page/stockpage?code=${props.quotedata.code}&market=${props.quotedata.market}`))
    } else {
      setShareId(encodeURIComponent(`dfcft://stock?market=${props.quotedata.market}&code=${props.quotedata.code}`))
    }

    if (appfenxiang > -1) {
      setMdtype("gghq")
    }
    let price = zoomData(props.quotedata.price, props.quotedata.decimal59)
    let zdf = zoomData(props.quotedata.zdf, props.quotedata.decimal152, true)
    let zde = zoomData(props.quotedata.zde, props.quotedata.decimal59)
    // console.log('微信注入')
    window.wxshare({
      // @ts-ignore
      desc: `最新价:${price ?? "-"}\n涨跌额:${zde ?? "-"}\n涨跌幅:${zdf ?? "-"}...`,
      title: `${props.quotedata.name} ${props.quotedata.code} 涨跌幅:${zdf ?? "-"}`,
      link: window.location.href,
      imgUrl: "https://g1.dfcfw.com/g4/202112/20211206191716.png",
    })
  }, [props.quotedata.quotecode])

  // useEffect(() => {}, [])

  return (
    <footer className="comm-footer">
      <ul className="channels">
        <li>
          <a href="//wap.eastmoney.com/channel/list.html?channel=8&column=345">资讯</a>
        </li>
        <li>
          <a href="//mguba.eastmoney.com/mguba/">股吧</a>
        </li>
        <li>
          <a href="https://emdata.eastmoney.com/home/indexh5.html">数据</a>
        </li>
        <li>
          <a href="//wap.eastmoney.com/quota/hq">行情</a>
        </li>
        <li>
          <a href="//wap.eastmoney.com/my/favor/list">自选</a>
        </li>
        <li id="6">
          <div className="wrap-nav">
            <NavIcon />
          </div>
          导航
        </li>
      </ul>
      <ul className="versions">
        <li>
          <a href="#" className="active">
            触屏版
          </a>
        </li>
        <li>
          <a href="https://www.eastmoney.com/default.html">电脑版</a>
        </li>
      </ul>
      <ul className="operates">
        <li onClick={clickAdvise}>
          <div className="wrap">
            <div className="wrap-advise-icon">
              <AdviseIcon />
            </div>
            给网站提点意见
          </div>
        </li>
        <li onClick={clickDownloadApp}>
          <div className="wrap">
            <div className="wrap-mobile-icon">
              <MobileIcon />
            </div>
            下载APP
          </div>
        </li>
      </ul>
      <div className="low-version-tips" onClick={clickLowVersion}>
        <LowVersionIcon />
        <span className="low-version-title">低版本下载指南</span>
      </div>
      <p>手机东方财富网 eastmoney.com</p>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_top" className="network-bah">
        网站备案号:沪ICP备05006054号-11
      </a>
      <p className="description">
        郑重声明：本网站所刊载的所有资料及图表仅供参考使用。投资者依据本网站提供的信息、资料及图表进行金融、证券等投资所造成的盈亏与本网站无关。本网站如因系统维护或升级而需暂停服务，或因线路及超出本公司控制范围的硬件故障或其它不可抗力而导致暂停服务，于暂停服务期间造成的一切不便与损失，本网站不负任何责任。
      </p>
      {!props.hide_fix_bottom && <div className="comm-fixed-bottom"></div>}
    </footer>
  )
}
